import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { HeaderComponent } from './Header.component'

class HeaderContainer extends Component {
  static propTypes = {
    api: PropTypes.object,
    handleFilterOpen: PropTypes.func,
    setSearch: PropTypes.func,
    unsetSearch: PropTypes.func,
    handleExportDialogOpen: PropTypes.func,
    closeFilterOnExportClick: PropTypes.func,
    titleFormatter: PropTypes.object
  }

  buildSummary() {
    if (this.props.pagination && !this.props.pagination.basicPaginationEnabled) {
      let template = this.props.pagination.paginationSummary
      const pagination = this.props.api.getPagination()
      const totalItems = this.props.api.getTotalItems()

      if (pagination.pagesize >= this.props.api.getTotalItems()) {
        return false
      }

      const start = (((pagination.offset - 1) * pagination.pagesize) + 1)
      const intermediateTotal = (start + pagination.pagesize) - 1
      const end = totalItems < intermediateTotal ? totalItems : intermediateTotal

      template = template.replace('{1}', start)
      template = template.replace('{2}', end)
      template = template.replace('{3}', totalItems)

      return template
    }

    return false
  }

  handleFilterOpenClick = (evt) => {
    evt.preventDefault()

    this.props.handleFilterOpen()
  }

  handleExportOpenClick = (evt) => {
    evt.preventDefault()

    this.props.closeFilterOnExportClick()
    this.props.handleExportDialogOpen()
  }

  handleSearchOpenClick = (evt) => {
    evt.preventDefault()

    this.props.handleSearchOpen()
  }

  /**
   * Assembles injected labels and on the fly styling
   */
  buildSubStyling() {
    let output = {
      label: {
        content: '',
        styling: {}
      },
      styling: {}
    }

    if (this.props.titleFormatter && this.props.titleFormatter.formatter && this.props.env.checkFunction(this.props.titleFormatter.formatter)) {
      output = this.props.env.callFunction(this.props.titleFormatter.formatter, [this.props.title])
    }

    return output
  }

  render() {
    const subStyling = this.buildSubStyling()

    const events = {
      handleFilterOpenClick: this.handleFilterOpenClick,
      handleExportOpenClick: this.handleExportOpenClick,
      handleSearchOpenClick: this.handleSearchOpenClick
    }

    const { analytics, multiselect, i18n, title, filterDrawerOpen, updateSearchValue, setSearch, search, unsetSearch, api, download, headerButtons, env, selectedRows } = this.props

    return (
      <HeaderComponent
        analytics={analytics}
        subStyling={subStyling}
        multiselect={multiselect}
        search={search}
        selectedRows={selectedRows}
        env={env}
        download={download}
        api={api}
        i18n={i18n}
        title={title}
        filterDrawerOpen={filterDrawerOpen}
        updateSearchValue={updateSearchValue}
        events={events}
        headerButtons={headerButtons}
        setSearch={setSearch}
        unsetSearch={unsetSearch}
        summary={this.buildSummary()}
      />
    )
  }
}

export default HeaderContainer
